import { useUserState } from '@juvare/contact-management/ui/hooks';
import React from 'react';
import { useSearchParams } from 'react-router';
import { getDefaultMissionsTab } from '../../mission-list/utils/getDefaultMissionsTab';
export const useMissionTab = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const userState = useUserState();
    const missionTab = searchParams.get('missionTab') || getDefaultMissionsTab(userState);
    const setMissionTab = React.useCallback((value) => {
        setSearchParams((prevValues) => {
            prevValues.set('missionTab', value);
            return prevValues;
        }, { replace: true });
    }, [setSearchParams]);
    return {
        missionTab,
        setMissionTab,
    };
};
